import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUniqueVoucherLocation } from '@/shared/model/unique-voucher-location.model';

const baseApiUrl = 'api/unique-voucher-locations';
const baseSearchApiUrl = 'api/_search/unique-voucher-locations?query=';

export default class UniqueVoucherLocationService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUniqueVoucherLocation> {
    return new Promise<IUniqueVoucherLocation>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUniqueVoucherLocation): Promise<IUniqueVoucherLocation> {
    return new Promise<IUniqueVoucherLocation>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUniqueVoucherLocation): Promise<IUniqueVoucherLocation> {
    return new Promise<IUniqueVoucherLocation>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
